import type { HighlightTemplate } from './types';
import { Template01 } from './templates/Template01';
import { Template02 } from './templates/Template02';
import { Template03 } from './templates/Template03';
import { Template04 } from './templates/Template04';
import { Template05 } from './templates/Template05';
import { Template06 } from './templates/Template06';
import { Template07 } from './templates/Template07';

export const templates: HighlightTemplate[] = [
  Template01,
  Template02,
  Template03,
  Template04,
  Template05,
  Template06,
  Template07,
];
